import { memo } from 'react';
import { MButton } from '@Components/Base';
import { Form } from 'antd';

import styles from './footer-buttons.module.css';

interface EditButtonsProps {
  disabledSaveForm: boolean;
  disabledDeleteForm: boolean;
  disabledSubmitForm: boolean;
  onDeleteRequest: () => void;
  onSaveAsDraft: () => void;
}

const EditButtons: React.FC<EditButtonsProps> = ({
  disabledSaveForm,
  disabledDeleteForm,
  disabledSubmitForm,
  onDeleteRequest,
  onSaveAsDraft,
}) => {
  return (
    <>
      <Form.Item>
        <MButton
          danger
          disabled={disabledSaveForm || disabledDeleteForm}
          onClick={onDeleteRequest}
        >
          Delete Request
        </MButton>
      </Form.Item>
      <Form.Item>
        <MButton
          type="secondary"
          disabled={disabledSaveForm}
          onClick={onSaveAsDraft}
          className={styles.secondaryBtn}
        >
          Save Changes
        </MButton>
      </Form.Item>
      <Form.Item>
        <MButton
          type="primary"
          htmlType="submit"
          disabled={disabledSaveForm || disabledSubmitForm}
        >
          Submit
        </MButton>
      </Form.Item>
    </>
  );
};

export default memo(EditButtons);
